import { RootAppState } from 'store/configureStore'

export const materialClipboardSelector = (state: RootAppState) =>
  state.materials.materialSelectorClipboard

export const remnantStrategyModalParams = (state: RootAppState) =>
  state.materials.remnantStrategyModal
